<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getDepositSettlementList" :total-size="totalNumber" :page-size="pageSize" ref="table" isAddPageToRouter
    :isOutside="isOutside" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
     <wt-table   ref="tables" :list="tableData">
       <template slot="before">
          <el-table-column label="订单号">
            <template slot-scope="scope">
              {{scope.row.orderNumber}}
            </template>
          </el-table-column>
          <el-table-column label="支付商户订单号">
            <template slot-scope="scope">
              {{scope.row.paymentDetails.payOrderId}}
            </template>
          </el-table-column>
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              {{scope.row.goodsName}}
            </template>
          </el-table-column>
          <el-table-column label="用户姓名">
            <template slot-scope="scope">
              {{scope.row.userName}}
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              {{scope.row.userMobile}}
            </template>
          </el-table-column>
          <el-table-column label="母亲姓名">
            <template slot-scope="scope">
              {{scope.row.motherName}}
            </template>
          </el-table-column>
          <el-table-column label="母亲证件类型/号码">
            <template slot-scope="scope">
              {{scope.row.certificateNumber}}
            </template>
          </el-table-column>
          <el-table-column label="母亲手机号">
            <template slot-scope="scope">
              {{scope.row.motherPhone}}
            </template>
          </el-table-column>
          <el-table-column label="地区">
            <template slot-scope="scope">
              {{scope.row.address}}
            </template>
          </el-table-column>
          <el-table-column label="所属分子公司">
            <template slot-scope="scope">
              {{scope.row.organizationName}}
            </template>
          </el-table-column>
          <el-table-column label="支付时间">
            <template slot-scope="scope">
              {{scope.row.payTime}}
            </template>
          </el-table-column>
          <el-table-column label="支付方式">
            <template slot-scope="scope">
              {{scope.row.paymentChannel}}
            </template>
          </el-table-column>
          <el-table-column label="订单状态">
            <template slot-scope="scope">
              {{scope.row.orderStatus}}
            </template>
          </el-table-column>
          <el-table-column label="奖励状态">
            <template slot-scope="scope">
              {{scope.row.rewardStatus}}
            </template>
          </el-table-column>
          <el-table-column label="下单方式">
            <template slot-scope="scope">
              {{scope.row.depositAuditOrderingType}}
            </template>
          </el-table-column>
          <el-table-column label="订单金额">
            <template slot-scope="scope">
              {{scope.row.amount}}
            </template>
          </el-table-column>
        </template>
        <template>
          <slot/>
        </template>
     </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-deposit-settlement-table'

export default {
  name: 'pt-deposit-settlement-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getDepositSettlementList (page, next, size) {
      this.$emit('getDepositSettlementList', page, next, size)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
